import {Component, OnDestroy, OnInit, Pipe, PipeTransform, ViewChild} from '@angular/core';
import {ActivatedRoute, NavigationEnd, Router} from '@angular/router';
import {Location} from '@angular/common';
import {Store} from "@ngrx/store";
import {
  fetchTasks,
  toggleLoading,
  updateDealId,
} from "../../../redux";
import {DealService} from "../../services";
import {IDealCard} from "../../../shared/models";
import {MatTableDataSource} from "@angular/material/table";
import {MatPaginator} from "@angular/material/paginator";
import {MatSort, Sort} from "@angular/material/sort";
import {animate, state, style, transition, trigger} from "@angular/animations";
import {IBusinessUnit} from "../../../business-units/models";
import {ToastrService} from "ngx-toastr";
import {forkJoin, Observable, of, Subscription} from "rxjs";
import {addDeals} from "../../../redux/stores/deal/deal.actions";
import {UtilService} from "../../../shared/services";
import {ILookup} from "../../../../models";
import {showMandateModal, toggleNavigating} from "../../../redux/stores/config/config.actions";
import {DealModalComponent} from "../deal-modal/deal-modal.component";
import {ModalSize} from "../../../shared/services/util/util.service";
import {MatDialog} from "@angular/material/dialog";
import { DataService } from 'src/app/services/data/data.service';
import { LookupService } from 'src/app/services';
import { DealPreviewService } from '../../services/deal-preview.service';


enum DealView { CARD, TABLE }

@Component({
  selector: 'app-deal-list',
  templateUrl: './deal-list.component.html',
  styleUrls: ['./deal-list.component.scss'],
  // animations: [
  //   trigger('detailExpand', [
  //     state('collapsed', style({height: '0px', minHeight: '0'})),
  //     state('expanded', style({height: '*'})),
  //     transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
  //   ]),
  // ],
})
export class DealListComponent implements OnInit {

  DealView = DealView;
  // filterList: ILookup[] = [];
  pageView: DealView = DealView.CARD;
  dataSource: MatTableDataSource<IDealCard> = new MatTableDataSource();

  // dealsList: IDealCard[] = [];
  liveDealsPreviewList: IDealCard[] = [];
  dealStatusList: {key: string, value: string}[] = [];
  selectedStatusFilter: string = '';
  // sortedDeals: IDealCard[] = [];
  columnsToDisplay: string[] = [];
  allColumns = ['businessUnit', 'title', 'dealSize', 'secType', 'status', 'closeType', 'closeDate', 'created', 'edit'];
  investorColumns = ['title', 'dealSize', 'secType', 'status', 'closeType', 'closeDate', 'created', 'edit'];
  @ViewChild(MatPaginator) paginator?: MatPaginator;
  @ViewChild(MatSort) sort?: MatSort;

  constructor(
    public util: UtilService,
    private store: Store,
    private toastr: ToastrService,
    private dealService: DealService,
    private dealPreviewService: DealPreviewService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    // private location: Location,
    private dialog: MatDialog,
    public dataService: DataService,
    // private lookupService: LookupService
  ) {

    // set page view from local storage
    const savedPageView = localStorage.getItem('rondeivu-options-deal-pageview');
    if (savedPageView) {
      savedPageView === '0' ? this.pageView = DealView.CARD : this.pageView = DealView.TABLE;
    }
  }

  ngOnInit(): void {
    var action = this.activatedRoute.snapshot.queryParamMap.get("action");
    if (action === "add-deal" && (this.util.isAdmin() || this.util.isIssuer())) {
      // there is an action
      this.openDealModal();
    }

    // set table columns
    this.columnsToDisplay = this.util.isAdmin() ? this.allColumns : this.investorColumns;

    this.getDataFromSource();
  }


  getDataFromSource() {
    if (this.util.isInvestor()) {
      // the investor has a special GET of two different IDealCard Observables (dealsList, and the live deals available on Rondeivu)
      forkJoin({
        liveDeals: this.dealPreviewService.getLiveDealsPreview(),
        userDeals: this.dealService.getDeals()
      }).subscribe(({liveDeals, userDeals}) => {

        console.log("Preview Live Deals", liveDeals)
        console.log("Matched Deals", userDeals)
        // display the live deals that the user is not matched to
        let userDealsId = userDeals.map((x: IDealCard) => x.id);
        this.liveDealsPreviewList = liveDeals.filter(x => !userDealsId.includes(x.id));

        this.filterDeals(userDeals);
      });
    }
    else {
      // Issuers and Admin 
      this.dealService.getDeals().subscribe({
        next: (userDeals: IDealCard[]) => {
          this.filterDeals(userDeals);
        }
      })
    }

  }

  filterDeals(deals: IDealCard[]) {

    const uniqueStatuses = new Set(deals.map((deal: IDealCard) => deal.dealWorkflow));
    this.dealStatusList = [...uniqueStatuses].map(status => ({ key: status.trim().toLowerCase(), value: status }));
    this.dealStatusList.unshift({key: '', value: 'All'}); // add an "All" option at the beginning of the list

    this.dataSource = new MatTableDataSource(deals);
    this.dataSource.filterPredicate = (deals: IDealCard, filter: string): boolean => {
      return deals.dealWorkflow.trim().toLowerCase().includes(filter);
    };

    if (this.selectedStatusFilter) {
      this.applyStatusFilter(this.selectedStatusFilter);
    }

    if (!!this.sort) {
      this.dataSource.sort = this.sort;

      this.dataSource.sortingDataAccessor = (item: any, property: string) => {
        const value = item[property as keyof IDealCard];

        if (value === null || value === undefined) {
          // the property is not directly a key on the object, so reach into the chosen object
          if (property.includes('.')) {
            const keys = property.split('.');
            try {
              if (keys.length === 1) {
                return item[property as keyof IDealCard] ?? '';
              }
              else {
                var o = item[keys[0] as keyof IDealCard];
                if (o === null || o === undefined) {
                  return '';
                } else {
                  return o[keys[1]] ?? '';
                }
              }
            }
            catch (e) {
              return '';
            }
          }
          else {
            return '';
          }
        }

        if (typeof value === 'string') {
          return value.toLowerCase();
        }
        
        if (typeof value === 'number') {
          return value;
        }
        
        if (value instanceof Date) {
          return value.getTime();
        }
        
        return value;
      };
    }
  }

  applyStatusFilter(status: string) {
    console.log("Applying status filter: ", status);
    this.dataSource.filter = status.trim().toLowerCase();
  }

  setPageView(view: DealView) {
    this.pageView = view;

    localStorage.setItem('rondeivu-options-deal-pageview', view.toString());
  }
  
  // subscribeToDatasource() {
  //   console.log("Fetching Deals...");
  //   this.store.dispatch(updateDealId({dealId: ''}));
  //   this.store.dispatch(toggleLoading({loading: true}));
  //   //fetch the deals
  //   this.dealService.getDeals().subscribe({
  //     next: (deals: IDealCard[]) => {
  //       //todo ngrx entities should only be cached once
  //       this.store.dispatch(addDeals({deals: deals}));
  //       //set the table data
  //       this.dealsList = deals;
  //       this.filterCards();
  //       this.dataSource = new MatTableDataSource(this.dealsList);
  //       this.initDataSource();
  //       this.store.dispatch(toggleLoading({loading: false}));
  //     }, error: err => {
  //       this.toastr.error(" Unable to get deals!", $localize`:@@companyName:Rondeivu`);
  //       this.store.dispatch(toggleLoading({loading: false}));
  //       // todo Reload the nav items and tasks
  //       // if (err.status == 403) {
  //       //   this.util.getUserNavItems().then(() => {
  //       //     console.log('Fetching tasks...');
  //       //     this.store.dispatch({type: fetchTasks});
  //       //   });
  //       // }
  //     }
  //   });
  // }

  // initDataSource() {
  //   this.dataSource.filterPredicate = (data: IDealCard, filter: string) => {
  //     const lc_filter = filter.toLowerCase();
  //     let BU = !!data.businessUnit.displayName ? data.businessUnit.displayName.toLowerCase().includes(lc_filter) : false;
  //     let SL = !!data.businessUnit.slug ? data.businessUnit.slug?.toLowerCase().includes(lc_filter) : false;
  //     let PN = !!data.projectName ? data.projectName.toLowerCase().includes(lc_filter) : false;
  //     let AN = !!data.assetName ? data.assetName.toLowerCase().includes(lc_filter) : false;

  //     return BU || PN || AN || SL;
  //   };
  //   if (!!this.paginator) {
  //     this.dataSource.paginator = this.paginator;
  //   }
  //   if (!!this.sort) {
  //     this.dataSource.sort = this.sort;
  //   }
  // }

  viewDeal(deal: IDealCard) {
    this.store.dispatch(updateDealId({dealId: deal.id}));
    this.store.dispatch(toggleNavigating({navigating: true}));
    setTimeout(() => {
      this.router.navigate(['/', this.dataService.getBuSlug(), 'deals', deal.id]).then(() => {
        this.store.dispatch(toggleNavigating({navigating: false}));
      });
    }, 1000);
  }

  viewHistory(deal: IDealCard) {
    this.store.dispatch(toggleNavigating({navigating: true}));
    setTimeout(() => {
      this.router.navigate(['/' , this.dataService.getBuSlug(), 'history', 'deals'], {queryParams: {id: deal.id}}).then(() => {
        this.store.dispatch(toggleNavigating({navigating: false}));
      });
    }, 1000);
  }

  // filterCards() {
  //   // none selected so select all
  //   if (this.filterView.length == 0) {
  //     this.filterView = this.filterList.map((lookup: ILookup) => {
  //       return lookup.key.toUpperCase();
  //     });
  //   }
  //   const spoofUrl = ('/' + this.dataService.getBuSlug() + '/deals?status=' + this.filterView.join(',')).toLowerCase();
  //   this.location.go(spoofUrl);

  //   // this.filteredDeals = this.dealsList.filter((deal: IDealCard) => {
  //   //   return this.filterView.includes(deal.dealWorkflow);
  //   // });
  // }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  /**
   * Opens the deal modal on this page. Note, this dialog is required to be different from the deal modal that is
   * opened by the store action because the successful post must reload all the deals on the page.
   */
  openDealModal() {
    this.dialog.open(DealModalComponent, {
      width: this.util.getModalWidth(ModalSize.LARGE),
      disableClose: true
    })
    .afterClosed().subscribe((result: any) => {
      if (!!result) {
        this.dealService.addDeal(result).subscribe({
          next: (res: IDealCard) => {
            this.getDataFromSource();
            this.toastr.success("Deal Created!", $localize`:@@companyName:Rondeivu`);
          }, error: (err: any) => {
            this.toastr.error("Unable to create deal!", $localize`:@@companyName:Rondeivu`);
          }
        });
      }
    });
  }

  /**
   * Opens the mandate modal by dispatching the store action.
   */
  openMandateModal() {
    this.store.dispatch({type: showMandateModal});
  }

  //sort
  sortData(sort: Sort) {
    console.log("Trying to sort by ", sort.active, " in direction ", sort.direction);
    // const data = this.dealsList.slice();
    // if (!sort.active || sort.direction === '') {
    //   this.sortedDeals = data;
    //   return;
    // }

    // this.sortedDeals = data.sort((a: IDealCard, b: IDealCard) => {
    //   const isAsc = sort.direction === 'asc';
    //   switch (sort.active) {
    //     case 'projectName':
    //       return compare(a.projectName || '', b.projectName || '', isAsc);
    //     case 'displayName':
    //       return compare(a.businessUnit?.displayName || '', b.businessUnit?.displayName || '', isAsc);
    //     case 'closeDate':
    //       return compare(a.closeDate, b.closeDate, isAsc);
    //     case 'created':
    //       return compare(a.created, b.created, isAsc);
    //     case 'secDealType':
    //       return compare(a.secDealType, b.secDealType, isAsc);
    //     case 'dealCloseType':
    //       return compare(a.dealCloseType, b.dealCloseType, isAsc);
    //     case 'dealWorkflow':
    //       return compare(a.dealWorkflow, b.dealWorkflow, isAsc);
    //     case 'fundraiseSize':
    //       return compare(a.fundraiseSize, b.fundraiseSize, isAsc);
    //     default:
    //       return 0;
    //   }
    // });

    // this.dataSource = new MatTableDataSource(this.sortedDeals);
  }

  // private filterDealWorkflowListByProfile() {
  //   // switch (this.config.selected_business_unit.businessUnitType.toUpperCase()) {
  //   if (this.util.isAdmin()) {
  //     this.filterList = this.lookupService.lookups.dealWorkflowStatus;
  //   }
  //   else if (this.util.isInvestor()) {
  //     this.filterList = this.lookupService.lookups.dealWorkflowStatus.filter((status: ILookup) => {
  //       return ['LIVE', 'CLOSED'].includes(status.key);
  //     });
  //   }
  //   else if (this.util.isIssuer()) {
  //     this.filterList = this.lookupService.lookups.dealWorkflowStatus.filter((status: ILookup) => {
  //       return ['LIVE', 'PENDING', 'ONBOARDING', 'DECLINED', 'CLOSED'].includes(status.key);
  //     });
  //   }
  // }
}

function compare(a: number | string, b: number | string, isAsc: boolean) {
  return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
}



@Pipe({
  name: 'dealStatusFilter'
})
export class DealStatusFilterPipe implements PipeTransform {
  transform(items: IDealCard[], filterString: string): IDealCard[] {
    if (!items || !filterString) return items;

    const filters = filterString
      .split(',')
      .map(f => f.trim().toLowerCase())
      .filter(f => f);

    return items.filter(item =>
      filters.includes(item.dealWorkflow.toLowerCase())
    );
  }
}